import { render, staticRenderFns } from "./ProductBanDialog.vue?vue&type=template&id=52177d45"
import script from "./ProductBanDialog.vue?vue&type=script&lang=js"
export * from "./ProductBanDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports